module.exports = __webpack_public_path__ + "img/home_bottom.c2891e4f.png";